
      <span class="k-progress" [style.width]="progressComplete + '%'" [@progressState]="showProgress"></span>
      <ng-template [ngIf]='file.validationErrors && file.validationErrors.length > 0'>
        <span class="k-file-invalid-group-wrapper">
          <span class="k-file-group k-icon k-i-file-error"></span>
          <span class="k-file-state"></span>
        </span>
        <span class="k-file-name-size-wrapper">
          <span class="k-file-name k-file-name-invalid" [title]="file.name">{{ file.name }}</span>
          <span class="k-file-validation-message">{{ getFileValidationMessage(file) }}</span>
        </span>
      </ng-template>
      <ng-template [ngIf]='!file.validationErrors || file.validationErrors.length === 0'>
      <span class="k-file-group-wrapper">
          <span class="k-file-group k-icon" [ngClass]="fileGroupClass"></span>
          <span class="k-file-state"></span>
        </span>
        <span class="k-file-name-size-wrapper">
          <span class="k-file-name" [title]="file.name">{{ file.name }}</span>
          <span class="k-file-size">{{ getTotalFilesSizeMessage([file]) }}</span>
        </span>
      </ng-template>
      <kendo-upload-file-list-item-action-button
        [file]='file'
        [disabled]='disabled'
        [progress]='progressComplete'>
      </kendo-upload-file-list-item-action-button>
    